// extracted by mini-css-extract-plugin
export default {"hexagonContainer":"hexagoncomponent_hexagonContainer__0RB4v","hex1":"hexagoncomponent_hex1__mq4Zh","hex2":"hexagoncomponent_hex2__htxBf","logo":"hexagoncomponent_logo__v7w3n"};